<template>
 
  <div id="Vue"  >
 
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
    <el-tab-pane label="HS编码查询" name="first">
	
	  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
	  <el-form-item >
		  <el-input   v-model="form.keywords" class="input-with-select" @keyup.enter.native="onSubmit">
			<el-select  v-model="form.type" slot="prepend" placeholder="" style="width:132px">
			  <el-option label="编码" value="code"></el-option> 
			  <el-option label="名称" value="name"></el-option>
			  
			</el-select> 
		  </el-input>
	  </el-form-item>  
 
	  
	  <el-form-item>
		<el-button type="primary" :loading="loading" @click="onSubmit" >查询 </el-button>
	  </el-form-item>
	  </el-form>
	
	
	</el-tab-pane>
 
     
  </el-tabs>
    
 
  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  <el-table id="dataList" v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
	
     >

    <el-table-column
       
      prop="CODE"
      label="编码"
      min-width="15%">
    </el-table-column>

    <el-table-column
      prop="NAME"
      label="商品名称"
      min-width="30%">
    </el-table-column>
    <el-table-column
      prop="UNIT"
      label="单位"
      min-width="6%"> 
    </el-table-column>	
    <el-table-column
      prop="ST_DATE"
      label="生效日期"
      min-width="10%">  
    </el-table-column>
    <el-table-column
      prop="END_DATE"
      label="失效日期"
      min-width="10%">  
    </el-table-column>

    <el-table-column
      prop="ZSSL_SET"
      label="征税税率"
      min-width="10%">
 
    </el-table-column>
   <el-table-column
      prop="TSL"
      label="退税率"
      min-width="10%">
 
    </el-table-column>
	
  </el-table>
   <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
 
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
 				
  </div> 
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
			activeName: 'first',
	    	componentName: 'info',
		    userInfo: {},
			page: 1,
			size:10,
			total: 0,
			user_id: 0,
			loading: false,
			login_state : false,
			check_code: 100,
			check_state: 0,
			check_info: '',
			email: '',
			status:true,
            tableData: [],
			form:{ keywords:'',  
				   type:'code',
				 }, 
			}  
        },
        methods: {
			handlePageChange(val) {
				this.page = val;
 
				this.getInfo()
			},	
		    onSubmit(){
		 	  if (this.form.keywords == ''){
				    this.$message({
							message: '不能为空 ! ',
							type: 'warning'
							});
				    return;
				}
                this.check_state = 1;	 		    
			    this.email = this.form.email;
				this.getInfo();
				},
			handleClick(tab, event){
			    this.check_state = 0;
			},
			getInfo(){
				let that = this;  
					 				 
				that.loading = true; 
				  $.ajax({
					  type: "GET",
					  data:  {user_id: that.user_id,   
					          type: that.form.type,
							  keywords:that.form.keywords, 
							  page: that.page,
							  size: that.size,
							  },
					  url: "https://www.myferp.com/admin/email/hscode",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data)); 
 
                          that.total = data.data.info.count;
						  that.tableData = data.data.info.data;
							 
						  that.loading = false;					  
						  }
					  });
		    },
			
 
 

		},
        mounted() {   
				let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);    
				let info = {}; 
				if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				    info = JSON.parse(userInfo);
				    this.user_id = info.id;  
					}
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/hsCode.vue